import { Pages } from "./Pages";

export enum UserRole {
    SUPERADMIN = "SUPERADMIN",
    ADMIN = "RESTAURANT_MANAGER",
    MEMBER = "MEMBER"
}

declare type AppContextType = {
    setPage : (p : Pages) => void,
    showSnackbar : (message : string, type: 'info' | 'success' | 'error') => void
    userRole?: UserRole | null
};
export default AppContextType